export default __webpack_public_path__ + "static/media/3.18dea6fb.jpg";